import { checkIsAuthenticated } from '@/lib/api-client';
import { useQuery } from '@tanstack/react-query';

/** `pollMs` re-checks on that interval (while the tab is visible). */
export function useIsAuthenticated({ pollMs }: { pollMs?: number } = {}) {
  return useQuery({
    queryKey: ['is-authenticated'],
    queryFn: checkIsAuthenticated,
    refetchInterval: pollMs ?? false,
  });
}
